import React from 'react';
import * as Sentry from '@sentry/browser';
import { submitAllDataToSlowForm } from '../utils/browserUtils';
import { getData } from '../utils/sessionStorage';
import { AppConstants } from '../utils/constants';
import LoadingScreen from '../components/EnrollmentForm/LoadingScreen';
import styles from '../styles/SlowEnrollmentError.module.scss';

const SlowEnrollmentError = () => {
  window.setTimeout(submitAllDataToSlowForm, 2000);

  const userEmail = getData(AppConstants.userEmail);

  Sentry.withScope((scope) => {
    scope.setExtra('userEmail', userEmail);
    Sentry.captureMessage('Error submitting SlowForm to Pardot [v3]');
  });

  return (
    <>
      <p className={styles.errorContainer}>
        There was an error submitting your data. This page will automatically attempt to resubmit your responses. If you
        are repeatedly seeing this page please contact support@pathrise.com
      </p>
      <LoadingScreen />
    </>
  );
};

export default SlowEnrollmentError;
